// =============================================================================
// FILE:
// frontend/src/ipe/pms/components/site_store_dashboard/SiteStoreConsumptionHistorySection.jsx
// =============================================================================

import React, {
  useEffect,
  useState
} from "react";

import {
  Wrench
} from "lucide-react";

import executionStyles
  from "./siteStoreExecutionStyles";

import axiosClient
  from "../../../../api/axiosClient";


// =============================================================================
// COMPONENT
// =============================================================================

export default function SiteStoreConsumptionHistorySection({

  row

}) {

  // ===========================================================================
  // STATE
  // ===========================================================================

  const [loading, setLoading] =
    useState(false);

  const [consumptionRows, setConsumptionRows] =
    useState([]);

  const [error, setError] =
    useState("");


  // ===========================================================================
  // LOAD CONSUMPTION HISTORY
  // ===========================================================================

  const loadConsumptionHistory =
    async () => {

      try {

        setLoading(true);

        setError("");

        const response =
        await axiosClient.get(

            "/api/pms/task-execution-update/material-consumption-history",

            {
            params: {

                project_id:
                row.project_id,

                material_id:
                row.material_id
            }
            }
        );

        const allRows =
          response?.data?.data || [];

        // ==============================================================
        // FILTER MATCHING RECORDS
        // ==============================================================

        setConsumptionRows(
        allRows
        );

      } catch (err) {

        console.error(err);

        setError(

          err?.response?.data?.message ||

          "Failed to load consumption history"
        );

      } finally {

        setLoading(false);
      }
    };


  // ===========================================================================
  // LOAD ON OPEN
  // ===========================================================================

  useEffect(() => {

    if (row) {

      loadConsumptionHistory();
    }

  }, [row]);


  // ===========================================================================
  // RENDER
  // ===========================================================================

  return (

    <div style={executionStyles.section}>


      {/* ================================================================ */}
      {/* TITLE */}
      {/* ================================================================ */}

      <div style={executionStyles.sectionTitle}>

        Material Consumption History

      </div>


      {/* ================================================================ */}
      {/* LOADING */}
      {/* ================================================================ */}

      {
        loading && (

          <div style={executionStyles.loadingBox}>

            Loading consumption history...

          </div>
        )
      }


      {/* ================================================================ */}
      {/* ERROR */}
      {/* ================================================================ */}

      {
        error && (

          <div style={executionStyles.errorBox}>

            {error}

          </div>
        )
      }


      {/* ================================================================ */}
      {/* EMPTY */}
      {/* ================================================================ */}

      {
        !loading &&
        !error &&
        consumptionRows.length === 0 && (

          <div style={executionStyles.emptyBox}>


            <Wrench
              size={40}
              style={{
                marginBottom: 12,
                color: "#9ca3af"
              }}
            />

            <div>

              No consumption history found

            </div>

          </div>
        )
      }


      {/* ================================================================ */}
      {/* TABLE */}
      {/* ================================================================ */}

      {
        !loading &&
        consumptionRows.length > 0 && (

          <div style={executionStyles.tableWrap}>


            <table style={executionStyles.table}>


              <thead>

                <tr>

                  <th style={executionStyles.th}>
                    Consumption Date
                  </th>

                  <th style={executionStyles.th}>
                    Project
                  </th>

                  <th style={executionStyles.th}>
                    Remarks
                  </th>

                  <th style={executionStyles.th}>
                    Status
                  </th>

                  <th
                    style={{
                      ...executionStyles.th,
                      textAlign: "right"
                    }}
                  >
                    Consumed Qty
                  </th>

                </tr>

              </thead>


              <tbody>

                {
                  consumptionRows.map((item) => (

                    <tr key={item.id}>


                      <td style={executionStyles.td}>

                        {
                          item.consumption_date || "-"
                        }

                      </td>


                      <td style={executionStyles.td}>

                        {
                          item.project_name || "-"
                        }

                      </td>


                      <td style={executionStyles.td}>

                        {
                          item.remarks || "-"
                        }

                      </td>


                      <td style={executionStyles.td}>


                        <span
                          style={
                            executionStyles.statusConsumed
                          }
                        >

                          CONSUMED

                        </span>

                      </td>


                      <td style={executionStyles.tdRight}>

                        {
                          item.consumed_qty || 0
                        }

                      </td>

                    </tr>
                  ))
                }

              </tbody>

            </table>

          </div>
        )
      }

    </div>
  );
}